<template>
    <v-flex md6 xs12>
        <BnHelpField
            :name="wrapperAttrs.mezo"
            :active="!!wrapperAttrs.help"
        >
            <template #two>
                <div class="d-flex">
                    <v-select
                        v-if="teaorTypeItems.length > 1"
                        v-model="teaorType"
                        color="secondary"
                        :disabled="!isEditable"
                        item-text="key"
                        item-value="value"
                        :items="teaorTypeItems"
                        label="TEÁOR típus"
                        :outlined="cfg.props.outlined"
                        persistent-placeholder
                        style="min-width: 25%; padding-right: 8px;"
                        @change="teaor = null"
                    />
                    <v-autocomplete
                        v-model="teaor"
                        :disabled="!teaorInputAttrs.editable"
                        :error-messages="errorMsg"
                        :id="teaorInputAttrs.mezo"
                        :item-text="teaorInputAttrs.itemsText"
                        :item-value="teaorInputAttrs.itemsValue"
                        :items="teaorInputAttrs.items"
                        :label="teaorInputAttrs.label"
                        color="secondary"
                        :outlined="cfg.props.outlined"
                        persistent-placeholder
                        style="min-width:75%;"
                        @change="errorMsg = undefined"
                    />
                </div>
            </template>
        </BnHelpField>
    </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import BnHelpField from './BnHelpField.vue';
import EventBus from '../../modules/EventBus';
import { listTypes } from '../../modules/List';

export default {
    name: 'BnTeaorInput',
    components: {BnHelpField},
    props: {
        attributes: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isEditable: this.attributes.editable,
            teaorType: undefined,
            errorMsg: undefined,
        };
    },
    mounted() {
        this.$store.dispatch('getList', this.teaorInputAttrs.resource);
        this.teaor = this.getTeaor();
        this.teaorType = this.getTeaorType();
        this.$nextTick(() => {
            EventBus.$on('disable-fields', () => {
                this.isEditable = false;
            });
        });
    },
    computed: {
        ...mapGetters(['getErrors', 'lists']),
        wrapperAttrs() {
            return {
                mezo: this.attributes.mezo,
                help: this.attributes.help,
            };
        },
        teaorInputAttrs() {
            return {
                label: this.teaorInputLabel,
                editable: this.isEditable,
                path: this.attributes.path,
                mezo: this.attributes.mezo,
                resource: listTypes.teaor,
                items: this.teaorInputItems,
                itemsText: 'value',
                itemsValue: 'key',
            };
        },
        teaorInputLabel() {
            if (this.attributes.label) return this.attributes.label;
            const labelCodePrefix = this.teaorTypeItems.length === 1 ? this.teaorTypeItems[0].key : '';
            return `Fő tevékenység TEAOR ${labelCodePrefix} kódja`;
        },
        teaorInputItems() {
            const listType = this.getTeaorListType();
            return this.lists[listType] ? this.lists[listType] : [];
        },
        teaorTypeItems() {
            return [
                {key: '\'25',value: '25'}
            ];
        },
        entity() {
            return this.attributes.path.split('.')[0];
        },
        teaor: {
            get() {
                return this.attributes.path
                    ? this.$getNestedPropVal(this.$store.getters, this.attributes.path.split('.'))
                    : null;
            },
            set(val) {
                if (this.attributes.path) {
                    this.$store.commit('setProp', {path: this.attributes.path, value: val});
                }
            },
        },
    },
    methods: {
        getTeaor() {
            const teaor = (this.$store.getters[this.entity].teaor)?.replace('´', "'");
            return String(teaor).length !== 4 ? teaor : null;
        },
        getTeaorType() {
            let teaorType = this.teaorTypeItems[0].value;
            if (this.teaor && String(this.teaor).length !== 4) teaorType = String(this.teaor).substring(1, 3);
            return teaorType;
        },
        getTeaorListType() {
            let teaorListType;
            if (this.teaorType === '08') teaorListType = 'teaorList';
            if (this.teaorType === '25') teaorListType = 'teaor25List';
            return teaorListType;
        },
    },
    watch: {
        getErrors(errors) {
            if (this.teaorInputAttrs.mezo in errors) {
                this.errorMsg = errors[this.teaorInputAttrs.mezo];
            }
        },
    },
};
</script>
